export const enum ShelfType {
	REGULAR = "REGULAR",
	HANGCELL = "HANGCELL",
}
